import {Animate} from "react-simple-animate";
import ResetPasswordGetCode from "./ResetPasswordGetCode";
import React, {useState} from "react";
import ResetPasswordValidate from "./ResetPasswordValidate";
import ResetPasswordChange from "./ResetPasswordChange";
import ResetPasswordSuccess from "./ResetPasswordSuccess";

export default function ResetPassword({setKnowsPassword}) {

    const [email, setEmail] = useState("");
    const [code, setCode] = useState("");
    const [resetStep, setResetStep] = useState(1);

    return (
        <form
            className="lg:col-start-1 col-start-2 lg:col-end-13 col-end-12 row-start-3 row-end-13 text-2xl text-white">
            <Animate play start={{opacity: 0}} end={{opacity: 1, display: "flex", flexDirection: "column", gap: "1rem"}}
                     duration={0.7}>

                {resetStep === 1 ?
                    <ResetPasswordGetCode
                        setEmail={setEmail}
                        email={email}
                        setResetStep={setResetStep}
                    /> : null
                }

                {resetStep === 2 ?
                    <ResetPasswordValidate
                        code={code}
                        setCode={setCode}
                        email={email}
                        setResetStep={setResetStep}
                    /> : null
                }

                {resetStep === 3 ?
                    <ResetPasswordChange
                        code={code}
                        setCode={setCode}
                        email={email}
                        setEmail={setEmail}
                        setResetStep={setResetStep}
                    /> : null
                }

                {resetStep === 4 ?
                    <ResetPasswordSuccess
                        setKnowsPassword={setKnowsPassword}
                    /> : null
                }

                {resetStep !== 4 ?
                    <h3 className={"text-lg text-white/75"}>
                        Remembered your password? <span onClick={() => setKnowsPassword(true)}
                                                        className={"text-white underline cursor-pointer"}> Return to login</span>
                    </h3> : null
                }

            </Animate>
        </form>
    );
}